import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import CustomNavbar from "../CustomPermissions/CustomNavbar";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";
import { Button, Card, PageHeader, Badge } from "../common";

function UserAllCandidateListView(prop) {
  const [data, setData] = useState(null);
  const location = useLocation();
  const { state } = location;
  const [userPermissions, setUserPermissions] = useState([]);
  const stateValue = location.state && location.state["userPermissions"];
  const [monthlyRecords, setMonthlyRecords] = useState([]);
  const [pipelineAndTurnedUp, setPipelineAndTurnedUp] = useState("null");
  const [pipelineUnique, setPipelineUnique] = useState(0);
  const [name, setName] = useState("null");
  const [image, setImage] = useState("null");
  const [sop, setSop] = useState([]);
  const [isNewSop, setIsNewSop] = useState(false);
  const [username, setUsername] = useState("null");
  const [id, setId] = useState("null");
  const [showModal, setShowModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [candidateList, setCandidateList] = useState([]);
  const [userDefinedPermissions, setUserDefinedPermissions] = useState([]);

  const navigate = useNavigate();

  // Sign Out Handler
  const handleSignOut = () => {
    localStorage.removeItem("access_token");
    navigate("/");
  };

  // Fetch User Data on Component Mount
  useEffect(() => {
    if (localStorage.getItem("access_token") !== null) {
      fetchUserData();
    }
    if (state && state.userPermissions) {
      setUserPermissions(state.userPermissions);
    }
  }, []);

  // Fetch Updated User Data
  const fetchUserData = async () => {
    try {
      const response = await fetch(
        getApiUrl("/Docladder/GetUserDatafromUsernameOfAllCandidate/", false),
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      console.log("API Response:", data); // Log the full API response
      setId(data.records.id);
      setData(data.records);
      setName(data.records.name);
      setImage(data.records.image);
      setUsername(data.records.username);
      setCandidateList(data.all_entry); // Ensure this contains updated revenue
      setMonthlyRecords(data.monthly_records);
      setPipelineAndTurnedUp(data.pipelineandturnedup[0].pipline);
      setPipelineUnique(data.pipelineandturnedup[0].pipeline_unique || 0);

      const storedPermissions2 =
        JSON.parse(localStorage.getItem("user_defined_permissions")) || [];
      setUserDefinedPermissions(storedPermissions2);

      // Check for new SOP
      if (Array.isArray(data.sop) && data.sop.length > 0) {
        const sopData = data.sop[0];
        if (sopData.updated_date) {
          const updatedDate = new Date(sopData.updated_date)
            .toISOString()
            .split("T")[0];
          const currentDate = new Date().toISOString().split("T")[0];
          const diffInTime = new Date(currentDate) - new Date(updatedDate);
          const diffInDays = diffInTime / (1000 * 3600 * 24);
          setIsNewSop(diffInDays >= 0 && diffInDays <= 2);
        }
      } else {
        setIsNewSop(false);
      }
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    }
  };

  // Open Modal for Creating New Entry
  const openCreateModal = () => {
    setSelectedRecord(null);
    setShowModal(true);
  };

  // Open Modal for Editing Candidate Details
  const openEditModal = (record) => {
    setSelectedRecord(record);
    setShowModal(true);
  };

  // Close Modal
  const closeModal = () => {
    setShowModal(false);
    setSelectedRecord(null);
  };

  // Handle Record Creation or Update
  const handleSave = async () => {
    try {
      const formData = new FormData();
      console.log("Hello: ", id);
      formData.append("id", id);

      if (selectedRecord) {
        console.log("Hi");
        // Edit existing record
        console.log("Candidate ID: ", selectedRecord.id);
        formData.append("candidate_id", selectedRecord.id);
        formData.append("candidate_name", selectedRecord.candidate_name);
        formData.append("speciality", selectedRecord.speciality);
        formData.append("hospital", selectedRecord.hospital);
        formData.append("city", selectedRecord.city);
        formData.append("state", selectedRecord.state);
        formData.append(
          "remark",
          document.getElementById("remark").value || "No remarks"
        );
        formData.append("user_rec", id);
        formData.append("status", document.getElementById("status").value);
        formData.append("expected_revenue", document.getElementById("expected_revenue").value);
        formData.append("revenue", document.getElementById("revenue").value);
      } else {
        console.log("Create New record");
        // Create new record
        formData.append(
          "candidate_name",
          document.getElementById("candidateName").value
        );
        formData.append(
          "speciality",
          document.getElementById("speciality").value
        );
        formData.append("hospital", document.getElementById("hospital").value);
        formData.append("city", document.getElementById("city").value);
        formData.append("state", document.getElementById("state").value);
        formData.append(
          "remark",
          document.getElementById("remark").value || "No remarks"
        );
        formData.append("status", document.getElementById("status").value);
        formData.append("expected_revenue", document.getElementById("expected_revenue").value);
        formData.append("revenue", document.getElementById("revenue").value);
        formData.append("user_rec", id);

        // Append image if uploading a new one
        const imageInput = document.getElementById("image");
        if (imageInput && imageInput.files.length > 0) {
          formData.append("image", imageInput.files[0]);
        }
      }

      const url = getApiUrl("/Docladder/UpdateRecord/");
      const method = "PUT";
      const response = await fetch(url, {
        method,
        body: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to save record");
      }

      const responseData = await response.json();
      closeModal();
      fetchUserData(); // Refresh data after saving
    } catch (error) {
      console.error("Error saving record:", error);
      alert("Failed to save record. Please try again.");
    }
  };

  // Helper function to determine text color based on status (optional)
  const getTextColor = (status) => {
    switch (status) {
      case "resume_forwarded":
        return "#007bff"; // Dark Blue
      case "pipeline":
        return "#ffc107"; // Gold
      case "turned_up":
        return "#28a745"; // Green
      case "backout":
        return "red";
      case "not_selected":
        return "red";

      case "selected":
        return "#007bff"; // Dark Blue
      case "joined":
        return "#28a745"; // Green
      default:
        return "#000000"; // Default Black
    }
  };

  return (
    <div style={{ display: "flex" }}>
      {/* Sidebar */}
      <CustomNavbar />

      {/* Main Content Area */}
      <div className="flex-1 min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
        {/* Page Content */}
        <div className="p-6">
          {/* Page Header with Actions */}
          <div className="bg-white rounded-xl shadow-lg p-4 mb-6 border-b-4 border-indigo-500">
            <div className="flex justify-between items-center flex-wrap gap-3">
              <div>
                <h1 className="text-3xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                  📋 All Candidates
                </h1>
                <p className="text-gray-600 mt-1">View and manage all your candidates</p>
              </div>
              <Button variant="success" size="lg" icon="➕" onClick={() => openCreateModal()}>
                Upload Candidate
              </Button>
            </div>
          </div>

          {/* Candidate Details Table */}
          <Card shadow="xl">
            <div className="border-b border-gray-200 pb-4 mb-4">
              <h2 className="text-xl font-bold text-gray-800">📋 Candidate Details</h2>
              <p className="text-gray-600 text-sm">All your candidates</p>
            </div>


            <table
              className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden"
            >
              <thead>
                <tr className="bg-gradient-to-r from-purple-600 to-pink-600 text-white">
                  <th scope="col" className="py-3 px-4 border-b font-semibold">
                    #
                  </th>
                  <th scope="col" className="py-3 px-4 border-b font-semibold">
                    👤 Candidate
                  </th>
                  <th scope="col" className="py-3 px-4 border-b font-semibold">
                    🏥 Speciality
                  </th>
                  <th scope="col" className="py-3 px-4 border-b font-semibold">
                    🏥 Hospital
                  </th>
                  <th scope="col" className="py-3 px-4 border-b font-semibold">
                    🌆 City
                  </th>
                  <th scope="col" className="py-3 px-4 border-b font-semibold">
                    📍 State
                  </th>
                  <th scope="col" className="py-3 px-4 border-b font-semibold">
                    💰 Exp. Revenue
                  </th>
                  <th scope="col" className="py-3 px-4 border-b font-semibold">
                    💰 Revenue
                  </th>
                  <th scope="col" className="py-3 px-4 border-b font-semibold">
                    📊 Status
                  </th>
                  <th scope="col" className="py-3 px-4 border-b font-semibold">
                    📝 Remark
                  </th>
                  <th scope="col" className="py-3 px-4 border-b font-semibold">
                    📅 Date
                  </th>
                  <th scope="col" className="py-3 px-4 border-b font-semibold">
                    ⚙️ Action
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-300">
                {candidateList.map((record, index) => (
                  <tr key={record.id}>
                    <td className="py-2 px-4 border-b text-center">
                      {index + 1}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {record.candidate_name}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {record.speciality}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {record.hospital}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {record.city}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {record.state}
                    </td>
                    <td className="py-2 px-4 border-b text-center font-semibold text-indigo-600">
                      ₹{record.status === 'selected' ? ((parseFloat(record.expected_revenue) > 0 ? record.expected_revenue : record.revenue) || 0).toFixed(2) : '0.00'}L
                    </td>
                    <td className="py-2 px-4 border-b text-center font-bold text-green-600">
                      ₹{record.status === 'joined' ? parseFloat(record.revenue || 0).toFixed(2) : '0.00'}L
                    </td>
                    <td
                      className="py-2 px-4 border-b text-center"
                      style={{
                        color: getTextColor(record.status), // Optional: Change text color for better contrast
                      }}
                    >
                      {record.status}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {record.remark}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {record.date_entered}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      <button
                        className="btn btn-primary"
                        onClick={() => openEditModal(record)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>

          {/* Modal for Creating or Editing Records */}
          {showModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
              <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={closeModal}></div>
              <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-hidden">
                {/* Modal Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-gradient-to-r from-indigo-600 to-purple-600">
                  <h2 className="text-lg font-bold text-white">
                    {selectedRecord ? "Edit Candidate" : "Add New Candidate"}
                  </h2>
                  <button
                    onClick={closeModal}
                    className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/20 hover:bg-white/30 text-white transition-colors"
                  >
                    ✕
                  </button>
                </div>

                {/* Modal Body */}
                <div className="overflow-y-auto max-h-[calc(90vh-140px)] p-6">
                  <form className="space-y-4">
                    {selectedRecord ? (
                      // Edit Candidate Modal (Status and Revenue Only)
                      <>
                        <input type="hidden" id="candidateName" value={selectedRecord.candidate_name} />
                        <input type="hidden" id="speciality" value={selectedRecord.speciality} />
                        <input type="hidden" id="hospital" value={selectedRecord.hospital} />
                        <input type="hidden" id="city" value={selectedRecord.city} />
                        <input type="hidden" id="state" value={selectedRecord.state} />

                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1.5">Status</label>
                          <select
                            id="status"
                            defaultValue={selectedRecord.status}
                            className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white text-slate-800"
                          >
                            <option value="resume_forwarded">Resume Forwarded</option>
                            <option value="pipeline">Pipeline</option>
                            <option value="turned_up">Turned Up</option>
                            <option value="selected">Selected</option>
                            <option value="not_selected">Not Selected</option>
                            <option value="backout">Backout</option>
                            <option value="joined">Joined</option>
                          </select>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1.5">Expected Revenue</label>
                          <input
                            type="number"
                            id="expected_revenue"
                            defaultValue={selectedRecord.expected_revenue}
                            placeholder="Enter expected revenue (Selected only)"
                            className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1.5">Revenue</label>
                          <input
                            type="number"
                            id="revenue"
                            defaultValue={selectedRecord.revenue}
                            placeholder="Enter revenue"
                            className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1.5">Remark</label>
                          <input
                            type="text"
                            id="remark"
                            defaultValue={selectedRecord.remark || ""}
                            placeholder="Enter remark"
                            className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                          />
                        </div>
                      </>
                    ) : (
                      // Create New Candidate Modal
                      <>
                        {[
                          { id: "candidateName", label: "Candidate Name", type: "text", placeholder: "Enter candidate name" },
                          { id: "speciality", label: "Speciality", type: "text", placeholder: "Enter speciality" },
                          { id: "hospital", label: "Hospital", type: "text", placeholder: "Enter hospital" },
                          { id: "city", label: "City", type: "text", placeholder: "Enter city" },
                          { id: "state", label: "State", type: "text", placeholder: "Enter state" },
                        ].map((field) => (
                          <div key={field.id}>
                            <label className="block text-sm font-medium text-slate-700 mb-1.5">{field.label}</label>
                            <input
                              type={field.type}
                              id={field.id}
                              placeholder={field.placeholder}
                              className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                            />
                          </div>
                        ))}

                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1.5">Status</label>
                          <select id="status" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white text-slate-800">
                            <option value="resume_forwarded">Resume Forwarded</option>
                            <option value="pipeline">Pipeline</option>
                            <option value="turned_up">Turned Up</option>
                            <option value="selected">Selected</option>
                            <option value="not_selected">Not Selected</option>
                            <option value="backout">Backout</option>
                            <option value="joined">Joined</option>
                          </select>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1.5">Expected Revenue</label>
                          <input type="number" id="expected_revenue" placeholder="Enter expected revenue (Selected only)" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1.5">Revenue</label>
                          <input type="number" id="revenue" placeholder="Enter actual revenue (Joined only)" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1.5">Remark</label>
                          <input type="text" id="remark" placeholder="Enter remark" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                        </div>
                      </>
                    )}
                  </form>
                </div>

                {/* Modal Footer */}
                <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50">
                  <button
                    onClick={closeModal}
                    className="px-5 py-2.5 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSave}
                    className="px-5 py-2.5 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors"
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          )}


        </div >
      </div >
    </div >
  );
}

export default UserAllCandidateListView;
